// What each class is and how it plays, as the gun rack's class card reads it out. The rack lane owns the
// words; the rules live in sim/ (the class defs in sim/defs.ts, the prime / detonate verbs in
// sim/game.ts and sim/player.ts). When a class rule changes, change its lines here in the same PR.
//
// Buttons are written as tokens and drawn as PS5 glyphs (or keys, on mouse and keyboard):
//   {tri} △ class move   {r3} melee   {r2} fire   {r1} grenade   {circle} dodge   {l1} hover   {x} the engine   {dd} D-pad ▼ crate weapon

export interface ClassLine {
  /** the verb, in caps: PRIME, DETONATE, the move's name, the loop extender's name */
  k: string;
  text: string;
}

export interface ClassInfo {
  /** one deadpan line on who this is */
  bio: string;
  /** the dance, in the order you do it */
  lines: ClassLine[];
  /** what keeps you alive, or what to watch for */
  watch: string;
}

export const CLASS_INFO: ClassInfo[] = [
  {
    bio: 'Six rounds, steady hands, no patience for body shots. The one the posters are about.',
    lines: [
      { k: 'Prime', text: 'Pistol-whip a robot {r3}. Any angle.' },
      { k: 'Detonate', text: 'Headshot a primed robot {r2}. A body shot wastes the prime.' },
      { k: 'Hot Shot', text: 'For 3 s after a detonation, any headshot on an unshielded robot primes and detonates it in one.' },
      { k: 'Overload', text: 'Robots caught in the blast take +25% damage for 3 s.' },
    ],
    watch: 'No class move: dodge {circle} and pistol-whip are your defence. Big Iron is AP4 and cracks armour.',
  },
  {
    bio: 'Lives in the sky and leaves the ground to everyone else. Turns fastest, breaks easiest.',
    lines: [
      { k: 'Prime', text: 'Fire Dash {tri} through robots to prime them and set them burning. Aim it with the camera, in the air too.' },
      { k: 'Detonate', text: 'Shoot a primed robot {r2} while you are off the ground.' },
      { k: 'Sky-Stalker', text: 'An air detonation refunds 25% heat, and for 2.5 s the robots you prime from the air stay primed twice as long. Landing ends it.' },
      { k: 'Element Storm', text: 'Every detonation leaves a burning splash.' },
    ],
    watch: 'A 25 shield. Keep moving, keep high, and watch the heat.',
  },
  {
    bio: 'Nobody sees the Phantom arrive. The robots mostly see it leave.',
    lines: [
      { k: 'Warp', text: '{tri} blinks you 7.6 m and cloaks you for 1.4 s, so robots lose you. Shots that hit you mid-warp prime the shooter.' },
      { k: 'Prime', text: 'Backstab {r3} from behind, or from any angle while cloaked.' },
      { k: 'Detonate', text: 'Shoot a primed robot {r2} in the back, from cloak, or while it reels from your backstab.' },
      { k: 'Smoke & Mirrors', text: 'Each detonation cloaks you for 2.5 s and arcs to 3 nearby robots, finishing weak ones.' },
    ],
    watch: 'Cloak breaks if your shield is hit, you fire a shot that does not detonate, or you throw a grenade. Warp: 3 s cooldown.',
  },
  {
    bio: 'Slow, loud and built like a strongbox. Goes through the problem, not around it.',
    lines: [
      { k: 'Prime', text: 'Shield-bash a robot {r3}. Any angle.' },
      { k: 'Detonate', text: 'Charge {tri} into a primed robot. Bullets will not set it off.' },
      { k: 'Stagger Quake', text: 'The blast stuns for 1.5 s and strips a tier of armour for 6 s. Robots in the way get bowled over.' },
      { k: 'Shield Charge', text: 'Charging costs 30 shield. What it burns charges your crate weapon {dd} and your grenades.' },
    ],
    watch: 'The biggest shield in the posse. No charging below 30 shield, so let it come back.',
  },
];
